import React from 'react';
import { XIcon } from 'lucide-react';
import { motion } from 'framer-motion';
export function PainPoints() {
  const points = ['no saben qué estudiar', 'no conocen el tipo de pruebas', 'no llegan preparados al psicotécnico', 'fallan en la entrevista', 'no entrenan el físico de forma correcta', 'llegan nerviosos y sin una estrategia clara'];
  return <section className="py-5 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-black to-gray-900 border-t border-gray-800" data-id="element-111">
      <div className="max-w-3xl mx-auto" data-id="element-112">
        <div className="text-center mb-3" data-id="element-113">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-2 leading-tight" data-id="element-114">
            Cada año miles de aspirantes se presentan… pero muchos quedan afuera
          </h2>
          <p className="text-lg md:text-xl text-green-500 font-medium" data-id="element-115">
            No siempre por falta de capacidad. Muchas veces quedan afuera por
            algo mucho más simple:
          </p>
        </div>

        <div className="space-y-2 mb-3" data-id="element-116">
          {points.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.08
        }} className="bg-black/60 border border-red-900/40 rounded-lg px-4 py-2 flex items-center gap-3" data-id="element-117">
              <div className="flex-shrink-0 w-6 h-6 bg-red-900/80 rounded flex items-center justify-center" data-id="element-118">
                <XIcon className="w-4 h-4 text-red-400" data-id="element-119" />
              </div>
              <span className="text-base md:text-lg text-gray-200 font-medium" data-id="element-120">
                {point}
              </span>
            </motion.div>)}
        </div>

        <div className="text-center" data-id="element-121">
          <p className="text-xl md:text-2xl font-bold text-white mb-1" data-id="element-122">
            La mayoría improvisa.
          </p>
          <p className="text-lg md:text-xl text-red-500 font-bold" data-id="element-123">
            Y cuando improvisás en un ingreso tan competitivo, lo pagás caro.
          </p>
        </div>
      </div>
    </section>;
}